// extracted by mini-css-extract-plugin
module.exports = {"content":"ChangePhoneNumber_content__rmRjC","block":"ChangePhoneNumber_block__l5RZU","title":"ChangePhoneNumber_title__2bx2z","phone":"ChangePhoneNumber_phone__216Nm"};